export type SellerCatalogCounts = {
    doneCount: number;
    liveCount: number;
    onlineCount: number;
    sellerId: number;
    upcomingCount: number;
};

export const emptySellerCatalogCounts: SellerCatalogCounts = {
    doneCount: 0,
    liveCount: 0,
    onlineCount: 0,
    sellerId: 0,
    upcomingCount: 0,
};
